import { inject, Injectable, OnDestroy } from '@angular/core';
import { BehaviorSubject, Subscription } from "rxjs";
import { DateService, IsoDate } from '@softline/core';

export type DateChangeCallback = (date: string) => Promise<void>

@Injectable()
export class DateNavigatorService implements OnDestroy {

  private subscription?: Subscription;
  private dateService = inject(DateService);

  private readonly _date$ = new BehaviorSubject<IsoDate>(this.dateService.now());
  private dateChangeCallbacks = new Set<DateChangeCallback>();

  readonly date$ = this._date$.asObservable();

  get date(): IsoDate {
    return this._date$.getValue();
  }

  constructor() {
    this.date$.subscribe(async date => {
      const callbacks = Array.from(this.dateChangeCallbacks.values());
      await Promise.all(callbacks.map(cb => cb(date)));
    });
  }

  ngOnDestroy(): void {
      console.log('Service on destroy');

      if (this.subscription && !this.subscription.closed)
        this.subscription.unsubscribe();

      this.subscription = undefined;
  }

  onDateChange(callback: DateChangeCallback): () => void {
    this.dateChangeCallbacks.add(callback);
    return () => {
      this.dateChangeCallbacks.delete(callback);
    }
  }

  setDate(date: IsoDate): void {
    this._date$.next(date);
  }
}
